<script lang="ts" setup>
import { useWindowSize } from "@vueuse/core";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRoute } from "vue-router";

import { BREAKPOINTS } from "@/common/config";
import VocabNavbar from "@/components/header/VocabNavbar.vue";
import TheBanner from "@/components/TheBanner.vue";
import TheBreadcrumbs from "@/components/TheBreadcrumbs.vue";
import TheFooter from "@/components/TheFooter.vue";
import TheHeader from "@/components/TheHeader.vue";
import { useMenuStore, useSiteStateStore } from "@/stores";

const route = useRoute();
const { isMenuOpen } = storeToRefs(useMenuStore());
const { hasBanner } = storeToRefs(useSiteStateStore());

const { width: windowWidth } = useWindowSize();

const isMobileMenuOpen = computed(() => isMenuOpen.value && windowWidth.value < BREAKPOINTS.lg);

const breadcrumbs = computed(() => route.meta.breadcrumbs ?? []);
const isVocabularyTrainerRoute = computed(() => route.meta.isVocabularyTrainerRoute ?? false);
</script>

<template>
  <div class="app-layout">
    <TheBanner v-if="hasBanner" :inert="isMobileMenuOpen" />
    <TheHeader />
    <div v-if="breadcrumbs.length" :inert="isMobileMenuOpen" class="container">
      <div class="row">
        <TheBreadcrumbs :items="breadcrumbs" />
      </div>
    </div>
    <div v-if="isVocabularyTrainerRoute">
      <VocabNavbar />
    </div>
    <div
      class="app-layout__view pt-4 position-relative"
      :inert="isMobileMenuOpen"
      :class="{ 'app-layout__view--no-scroll': isMobileMenuOpen }"
    >
      <slot />
    </div>
    <TheFooter :inert="isMobileMenuOpen" />
  </div>
</template>
